import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { HierarchyUserInfoItem } from '../insight/config.insight.model';
import { InsightService } from '../insight/insight.service';
import { CacheDateItem } from '../insight/performance-data/cache-date.pd.model';
import { DataFilterOptions } from '../insight/performance-data/data-filter-options.pd.model';
import { ExtMetricDataItem } from '../insight/performance-data/metric.pd.model';
import { PerformanceDataService } from '../insight/performance-data/performance-data.service';
import { PeriodType } from '../widget/date-range.widget.model';

import { CardConfig } from './models/card-config.model';
import { PerformanceMetricData } from './models/performance-metric-data.model';
import { MetricModelTransformer } from './transformers/metric-model.transformer';

@Injectable()
export class MyPerformanceCardService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
        private readonly _insightService: InsightService,
        private readonly _pdService: PerformanceDataService,
    ) {}

    listHierarchyUserInfo(
        userIds: number[],
    ): Observable<HierarchyUserInfoItem[]> {
        return this._insightService.listHierarchyUserInfo(userIds);
    }

    listData(opts: DataFilterOptions): Observable<PerformanceMetricData[]> {
        return this._pdService.listData(opts).pipe(
            map((metrics: ExtMetricDataItem[]) => {
                const transformer = new MetricModelTransformer(opts.viewType);
                return transformer.transformList(metrics);
            }),
            catchError((error) => {
                console.error(error);
                throw new Error(
                    'performancedata/data/:viewTypeId/:periodTypeId failed',
                );
            }),
        );
    }

    listCacheDates(
        periodType: PeriodType,
        userId?: number,
    ): Observable<CacheDateItem[]> {
        return this._pdService.listCacheDates({
            periodTypeIds: [periodType],
            userIds: userId == null ? null : [userId],
        });
    }

    retrieveCardConfig(): Observable<CardConfig[]> {
        const params = new HttpParams().set('components', 'cardconfig');

        return this._http
            .get<CardConfig[]>(
                `${this._appConfig.API_ENDPOINTS.INSIGHT}/card/config`,
                { params },
            )
            .pipe(
                catchError((error) => {
                    console.error('Failed to fetch Card Config', error);
                    return of([]);
                }),
            );
    }
}
